import { IFilter } from "../Tools/IFilter";
import { FilterGroup } from "../Tools/FilterGroup";
import { FiltersController } from "../Tools/FiltersController";


export class ShowPriorityFilter implements IFilter {
    id: string;
    type: string;
    controller: FiltersController;
    parentGroup: FilterGroup;

    constructor(parentGroup: FilterGroup) {
        this.id = 'showPriority';
        this.type = 'showPriority';
        this.controller = new FiltersController();
        this.parentGroup = parentGroup;
    }

    html(): string {
        let html = `
        <form id="showPriorityForm">
            <div>
                <input id="showMDM" class="btn-default" type="radio" name="priority" value="MDM"> MDM
            </div>
            <div>
                <input id="showMarketPlace" class="btn-default" type="radio" name="priority" value="MKP_MDM"> MarketPlace MDM
            </div>
            <div>
                <input id="showReferenced" class="btn-default" type="radio" name="priority" value="REFERENCED"> Référencés
            </div>
            <div>
                <input id="showGeneric" class="btn-default" type="radio" name="priority" value="GENERIC"> Génériques
            </div>
            <div>
                <input id="showPlaceHolders" class="btn-default" type="radio" name="priority" value="PLACEHOLDERS"> Placeholders
            </div>
        </form>
        `;
        setTimeout(() => {
            if (this.parentGroup.isDestroyed) return;
            let form = $('#showPriorityForm');
            form.find('input[type="radio"]').each((_index, element) => {
                this.controller.addEventListener('change', () => {
                    let val = $(element).val() as string;
                    FilterGroup.filters.showPriority = val;
                    FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters);
                }, element.id);
            });

            if (FilterGroup.filters.showPriority) {
                form.find(`input[type="radio"][value="${FilterGroup.filters.showPriority}"]`).prop('checked', true);
            }
        }, 50);
        return html;
    }

    destroy(): void {
        this.controller.destroy();
    }

}